<template>
  <div
    id="checkoutVue"
    class="checkout-vue-form"
  >
    <section
      :is="Cart"
    />
    <section
      :is="AddOns"
    />
    <div class="address-and-hotel">
      <section
        :is="Address"
        @updateres="updateReservationFromAddress"
      />
      <section
        :is="HotelDetails"
        ref="HotelDetails"
      />
    </div>
    <div class="open middle-checkout-column">
      <div
        class="cart left-middle-checkout-column"
        :class="[ displayLeftColumn ? 'display' : 'no-display']"
      >
        <div
          v-if="order.active_discounts || order.customer_total_credit > 0"
          class="credits-and-discounts"
        >
          <h2
            v-if="order.active_discounts || order.customer_total_credit > 0"
            class="expandable_header credits-discounts"
          >
            {{ $t('checkout.payment.creditsAndDiscounts') }}
          </h2>
          <section
            :is="Credits"
            :order="order"
          />
          <section
            :is="DiscountForm"
            :activediscounts="order.active_discounts"
          />
        </div>
        <section
          :is="Protected"
          @updateorder="updateOrder($event)"
        />
        <section
          :is="TermForm"
          v-if="order.event_payment_term_options && order.event_payment_term_options.length > 1"
          :options="order.event_payment_term_options"
          :orderpaymentcount="order.payment_count"
          @order="getOrder"
        />
        <div
          v-if="order.payment_terms && order.payment_terms.length > 1 && order.event_payment_term_options.length > 1"
        >
          <PaymentTermDisplay
            v-for="(term, i) in order.payment_terms"
            :key="term.id"
            :currency="order.charge_currency"
            :index="i+1"
            :term="term"
          />
        </div>
        <div :class="[loadingClass]">
          <div class="loading-icon" />
        </div>
      </div>
      <div class="right-middle-checkout-column">
        <section
          :is="Review"
          @updateorder="updateOrder($event)"
        />
      </div>
    </div>
    <section
      :is="Payment"
      :order="order"
    />
  </div>
</template>

<script>
import AddOns from './add_ons'
import TableAddOns from './table_display_add_ons/add_ons'
import Address from './address'
import HotelDetails from './hotel_details'
import Cart from './sidebar_cart'
import Payment from './payment'
import Credits from '../cart/credit_selection'
import DiscountForm from '../cart/discount_form'
import TermForm from '../cart/payment_terms/term_form'
import PaymentTermDisplay from '../cart/payment_terms/term_display'
import Protected from './protected'
import CartApi from '../cart/cart_api'
import Review from './review'
import { mapMutations, mapState } from 'vuex'

export default {
  components: {
    Address,
    AddOns,
    Cart,
    Credits,
    DiscountForm,
    HotelDetails,
    Payment,
    Review,
    TermForm,
    PaymentTermDisplay
  },

  data() {
    const addOn = ( window.checkout_version === 'table_display' ?
      TableAddOns : AddOns)
    return {
      loadingOrder: false,
      currentSection: 'none',
      Cart:Cart,
      Credits: Credits,
      DiscountForm: DiscountForm,
      Address: Address,
      HotelDetails: HotelDetails,
      Review: Review,
      TermForm: TermForm,
      PaymentTermDisplay: PaymentTermDisplay,
      Payment: Payment,
      Protected: Protected,
      AddOns: addOn,
      order:{}
    }
  },
  computed: {
    ...mapState('checkout', {
      sectionComponent: state => state.section,
      topDiv: state => state.topDiv,
      hotelInCart: state => state.hotelInCart,
      number: state => state.number,
      // isGuest: state => state.isGuest,
    }),
    hasPaymentTerms() {
      return !(this.order.event_payment_term_options.slice(-1)[0] == 1)
    },
    loadingClass() {
      return (this.loadingOrder ? 'loading' : '')
    },
    displayLeftColumn(){
      return this.order.active_discounts || this.order.customer_total_credit > 0 ||
      (this.order.event_payment_term_options && this.order.event_payment_term_options.length > 1) ||
      this.order.protect_group_cost > 0
    },
    paymentTermsForSelect() {
      return this.order.event_payment_term_options.map(option => {
        return { text: this.$t(`payment_term_${option}`), value: option }
      })
    }
  },

  watch: {
    hotelInCart() {
      if (!this.hotelInCart) { this.sections.splice(3, 1) }
    },
    orderpaymentcount() {
      this.paymentCount = this.orderpaymentcount
    }
  },

  created(){
    CartApi.getOrder().then(order => {
      this.order = order
    })
  },

  async mounted() {
    // Delay Div load so it doesn't scroll to view on page load
    // let el = document.querySelector('#accountStatus').dataset.guest
    var current = this
    setTimeout(function() { current.setTopDiv(document.querySelector('.checkout-container')) }, 3000)
  },

  methods: {
    ...mapMutations('checkout', ['setTopDiv']),
    updateOrder(order){
      //updates payment term text on frontend when order changes in checkout
      this.order=order
    },
    getOrder() {
      this.loadingOrder = true
      return CartApi.getOrder().then(order => {

        if (order.id) {
          this.order = order

          // Notify of any amount changes.
          // Used on checkout page to process charge
          this.$emit('amount-update',
            { amountDecorated: order.amount_due_today_decorated,
              amount: order.amount_due_today,
              currency: order.charge_currency,
              itemCount: order.item_count,
              invalidItemsInCart: this.invalidItemsInCart,
              orderId: order.id,
              cart_version: order.cart_version })

          this.updateOrderInStore()
          this.updateRefundableAmount( order.protect_group_amount_raw, order.protect_group_amount,
            order.protect_group_cost, order.protect_group_cost_decorated)
        }

        // Update Navbar Badge
        if (order.item_count) {
          document.getElementById('badge').innerHTML = order.item_count
        } else {
          document.getElementById('badge').innerHTML = ''
        }

        this.loadingOrder = false
      }).catch(() => { this.loadingOrder = false })
    },
    updateReservationFromAddress(){
      this.$refs.HotelDetails.updateReservationFromAddress()
    }
  }
}
</script>
